import { render, staticRenderFns } from "./customerSource.vue?vue&type=template&id=de8776c4&"
import script from "./customerSource.vue?vue&type=script&lang=js&"
export * from "./customerSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de8776c4')) {
      api.createRecord('de8776c4', component.options)
    } else {
      api.reload('de8776c4', component.options)
    }
    module.hot.accept("./customerSource.vue?vue&type=template&id=de8776c4&", function () {
      api.rerender('de8776c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/customerSource.vue"
export default component.exports